(() => {
  const root = document.querySelector('.cm-about');
  if (!root || root.dataset.trackingBound) return;
  root.dataset.trackingBound = 'true';
  root.addEventListener('click', event => {
    const link = event.target.closest('a[data-cm-about-cta]');
    if (!link || !root.contains(link)) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed?.()) return;
    const payload = { cta_id: link.dataset.cmAboutCta, page_path: window.location.pathname };
    if (typeof window.Shopify?.analytics?.publish === 'function') {
      window.Shopify.analytics.publish('customima_about_cta', payload);
      return;
    }
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', 'customima_about_cta', {
      ...payload,
      transport_type: 'beacon'
    });
  });
})();
